import { barneyMediaArray } from './barneyMedia'
import { barneyBio } from './barneyBios'

import { tedReviewerReviewHinge, tedReviewerReviewBumble, robinReviewerReviewTinder } from './barneyReviewerReviews'
import { tedReviewerProfile, robinReviewerProfile } from './barneyReviewers'

export const tedProfileReviewHinge = {
  _id: 'tedProfileReviewHingeId',
  userId: 'barneyUserId',
  userEmail: 'barney@email.com',
  datingProfileId: 'barneyDatingProfileHingeId',
  reviewerProfileId: 'tedReviewerProfileId',
  reviewerEmail: 'ted@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `This is an awesome photo. You're definitely starting with a legendary vibe`,
      verdict: 'Very',
    },
    {
      feedback: `Interesting candid moment but I think you can do better.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Yes! Shows you as the life of the party in a candid way`,
      verdict: 'Very',
    },
    {
      feedback: `LOL! Great change of pace!`,
      verdict: 'Very',
    },
    {
      feedback: `Social proof! And you look good here too!`,
      verdict: 'Yes',
    },
    {
      feedback: `Ending with a glamor shot!`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Still not sure what you... do... but I don't think you want people to know, so it's as good as it'll be`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Uhh... too honest`,
        verdict: 'No', 
      },
      {
        feedback: `Shows you as a good wingman, but if you're on the apps why are you setting up your friend before yourself?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Kind of funny, but isn't your goal to be married?`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Barney is a charismatic enigma. He's very attractive and exciting but a bit difficult to define`,
    good: `You have super engaging photos, your style is great, and you have good friends. You're the life of the party`,
    notGood: `The prompts are turn-offs. Make these less questionable and you'll be matching with everyone`,
    verdict: `You have great photos, and if you improve your prompts, your most attractive self will be on display`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...tedReviewerReviewHinge },
  reviewerProfile: { ...tedReviewerProfile },
  bioItems: { ...barneyBio },
  mediaItems: [ ...barneyMediaArray ],
}

export const tedProfileReviewBumble = {
  _id: 'tedProfileReviewBumbleId',
  userId: 'barneyUserId',
  userEmail: 'barney@email.com',
  datingProfileId: 'barneyDatingProfileBumbleId',
  reviewerProfileId: 'tedReviewerProfileId',
  reviewerEmail: 'ted@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `This is an awesome photo. You're definitely starting with a legendary vibe`,
      verdict: 'Very',
    },
    {
      feedback: `Interesting candid moment but I think you can do better.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Yes! Shows you as the life of the party in a candid way`,
      verdict: 'Very',
    },
    {
      feedback: `LOL! Great change of pace!`,
      verdict: 'Very',
    },
    {
      feedback: `Social proof! And you look good here too!`,
      verdict: 'Yes',
    },
    {
      feedback: `Ending with a glamor shot!`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: barneyBio.aboutMe[0],
    hobbies: [barneyBio.hobbies[0], barneyBio.hobbies[1], barneyBio.hobbies[2], barneyBio.hobbies[3], barneyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Still not sure what you... do... but I don't think you want people to know, so it's as good as it'll be`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'This is kind of funny, especially when the photos are so evocative',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Uhh... too honest`,
        verdict: 'No', 
      },
      {
        feedback: `Shows you as a good wingman, but if you're on the apps why are you setting up your friend before yourself?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Kind of funny, but isn't your goal to be married?`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Barney is a charismatic enigma. He's very attractive and exciting but a bit difficult to define`,
    good: `You have super engaging photos, your style is great, and you have good friends. You're the life of the party`,
    notGood: `The prompts are turn-offs. Make these less questionable and you'll be matching with everyone`,
    verdict: `You have great photos, and if you improve your prompts, your most attractive self will be on display`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...tedReviewerReviewBumble },
  reviewerProfile: { ...tedReviewerProfile },
  bioItems: { ...barneyBio },
  mediaItems: [ ...barneyMediaArray ],
}

export const robinProfileReviewTinder = {
  _id: 'robinProfileReviewTinderId',
  userId: 'barneyUserId',
  userEmail: 'barney@email.com',
  datingProfileId: 'barneyDatingProfileTinderId',
  reviewerProfileId: 'robinReviewerProfileId',
  reviewerEmail: 'robin@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `This is an awesome photo. You're definitely starting with a legendary vibe`,
      verdict: 'Very',
    },
    {
      feedback: `Interesting candid moment but I think you can do better.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Yes! Shows you as the life of the party in a candid way`,
      verdict: 'Very',
    },
    {
      feedback: `LOL! Great change of pace!`,
      verdict: 'Very',
    },
    {
      feedback: `Social proof! And you look good here too!`,
      verdict: 'Yes',
    },
    {
      feedback: `Ending with a glamor shot!`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: barneyBio.aboutMe[0],
    hobbies: [barneyBio.hobbies[0], barneyBio.hobbies[1], barneyBio.hobbies[2], barneyBio.hobbies[3], barneyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Still not sure what you... do... but I don't think you want people to know, so it's as good as it'll be`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'This is kind of funny, especially when the photos are so evocative',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Uhh... too honest`,
        verdict: 'No', 
      },
      {
        feedback: `Shows you as a good wingman, but if you're on the apps why are you setting up your friend before yourself?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Kind of funny, but isn't your goal to be married?`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Barney is a charismatic enigma. He's very attractive and exciting but a bit difficult to define`,
    good: `You have super engaging photos, your style is great, and you have good friends. You're the life of the party`,
    notGood: `The prompts are turn-offs. Make these less questionable and you'll be matching with everyone`,
    verdict: `You have great photos, and if you improve your prompts, your most attractive self will be on display`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...robinReviewerReviewTinder },
  reviewerProfile: { ...robinReviewerProfile },
  bioItems: { ...barneyBio },
  mediaItems: [ ...barneyMediaArray ],
}